import React from "react";
import Commend3ConfirmDialog from "./Commend3ConfirmDialog";
import { Commend3Strategy } from "../Types";
import {
  STRATEGY_CHANGE_ACTION,
  STRATEGY_CHANGE_TITLE,
  strategyChangeMessage,
} from "../Commend3Constants";

type StrategyChangeWarningDialogProps = {
  pendingStrategy: Commend3Strategy | null;
  promoted?: boolean;
  onCancel: () => void;
  onConfirm: () => void;
};

const StrategyChangeWarningDialog = ({
  pendingStrategy,
  promoted,
  onCancel,
  onConfirm,
}: StrategyChangeWarningDialogProps) => (
  <Commend3ConfirmDialog
    isOpen={Boolean(pendingStrategy)}
    id="commend3-strategy-change-dialog"
    title={STRATEGY_CHANGE_TITLE}
    body={
      pendingStrategy
        ? strategyChangeMessage(pendingStrategy.name, Boolean(promoted))
        : ""
    }
    actionLabel={STRATEGY_CHANGE_ACTION}
    onCancel={onCancel}
    onConfirm={onConfirm}
  />
);

export default StrategyChangeWarningDialog;
